<template lang="html">
  <div
    class="form-group select-field__container mb-0"
    :class="{ 'has-error': !!error }"
  >
    <v-select
      v-if="!isReadOnly"
      flat
      dense
      outlined
      clearable
      :id="id"
      :hide-details="!!error"
      :data-testid="`${tid}-select-button`"
      :data-tourid="tourId"
      :disabled="disabled"
      :items="items"
      :label="label"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event)"
    ></v-select>

    <div v-else>
      <FieldLabel :text="label" :disabled="disabled" />

      <p
        v-if="!!value"
        class="select-field__value-label body-2 grey--text text--darken-4"
      >
        {{ valueLabel }}
      </p>

      <v-chip v-else small disabled class="label">{{
        $t('common.in_progress_status')
      }}</v-chip>
    </div>

    <p v-if="!!error" class="error-message">
      {{ error }}
    </p>
  </div>
</template>

<script>
import FieldLabel from '@/components/Core/FieldLabel'

export default {
  name: 'SelectField',

  components: {
    FieldLabel,
  },
  props: {
    id: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    items: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    tid: {
      type: String,
      default: 'select-field',
    },
    value: {
      type: String,
      required: false,
    },
    error: {
      type: String,
      required: false,
    },
    isReadOnly: {
      type: Boolean,
      required: false,
      default: true,
    },
    tourId: {
      type: String,
      required: false,
      default: 'select',
    },
  },
  computed: {
    valueLabel() {
      if (!this.value) return ''
      return this.items.find(item => item.value === this.value)?.text
    },
  },
}
</script>

<style lang="scss" scoped>
.select-field {
  &__container {
    position: relative;
  }

  &__value-label {
    font-size: 13px;
  }
}
</style>
